import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAllusercount = createAsyncThunk(
    'report/fetchAllUserReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/report/user/count');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all User Report');
        }
    }
);

export const fetchAllusercountMonthWise = createAsyncThunk(
    'report/fetchAllUserMonthWise',
    async (year: string, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/user/usernumber/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all User Report');
        }
    }
);

export const fetchAllUserRoleWise = createAsyncThunk(
    'report/fetchAllUserMonthWise',
    async (id: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/user/rolebased/${id}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all User Report');
        }
    }
);